import { render } from "./BaseComments.vue?vue&type=template&id=2a38cbd1&scoped=true"
import script from "./BaseComments.vue?vue&type=script&lang=js"
export * from "./BaseComments.vue?vue&type=script&lang=js"

import "./BaseComments.vue?vue&type=style&index=0&id=2a38cbd1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a38cbd1"]])

export default __exports__